export function toggleDefaultBranch(params: any, modeling: any) {

  return {
    args: [
      params.element('element')
    ],
    exec: function (element: any) {
      if (element.source.businessObject.default != element.businessObject) {
        return modeling.updateProperties(element.source,
          {
            default: element.businessObject
          });
      } else {
        return modeling.updateProperties(element.source,
          {
            default: null
          });
      }
    }
  };
}

toggleDefaultBranch.$inject = ['cli._params', 'modeling'];
